/**
 * User: Lior Elrom
 * Date: 4/12/16
 * Time: 5:47 PM
 */

'use strict';

const shuffle = require('lodash.shuffle');
const React = require('react');
const tracking = require('dibs-tracking');
const chatUtils = require('../../utils/chat').default;
const { localStorage } = require('dibs-browser-storage');
const { getUserId, getUserToken, isMasquerading, cookieJarConstants } = require('dibs-cookie-jar');
const copy = require('../copy/checkoutSurvey');
const styles = require('./CheckoutSurvey.scss');

require('dibs-elements/dist/buyer.css');

// components
const {
    PrimaryButton,
    ModalContainer,
    ModalCloseButton,
    BarHeader,
    ModalBody,
    Radio,
    TextArea,
    ExpandingArea
} = require('dibs-elements');

const getCurrentUserId = () => {
    const cookie = document.cookie || '';
    const isLoggedIn = !!getUserToken(cookie);
    return isLoggedIn ? getUserId(cookie, cookieJarConstants.MASQUERADE_BUYER, !isMasquerading(cookie)) : "Not logged in";
};
const trackSurvey = label => {
    const { step } = localStorage.getItem('checkoutSurveyInfo') || {};
    tracking.trackEvent({
        category: 'checkout',
        action: 'checkout form interaction',
        label: [label, step].join('|')
    });
};

class CheckoutSurvey extends React.Component {

    constructor(props) {
        super(props);
        this.onRadioClick = this.onRadioClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            isOpen: true,
            isDisabled: false,
            selected: '',
            additionalInfo: ''
        };
    }

    componentWillMount() {
        this.radioOptions = shuffle(copy.radioOptions);
    }

    componentDidMount() {
        localStorage.setItem('hasSeenCheckoutSurvey', true);
        trackSurvey('abandon checkout survey displayed');
    }

    onRadioClick(value) {
        this.setState({ selected: value });
    }

    closeModal() {
        this.setState({ isOpen: false });
    }

    onChange(event) {
        this.setState({additionalInfo: event.target.value});
    }

    onSubmit() {
        const {selected: reason, additionalInfo} = this.state;
        trackSurvey('abandon checkout survey submitted');
        chatUtils.track.checkoutSurveySubmitted({reason, additionalInfo});
        this.setState({
            isOpen: false,
            isDisabled: true
        });
    }

    getRadioOptions() {
        const shuffledOptions = this.radioOptions;
        const RadioOptions = shuffledOptions.map(option => this.renderRadio(option));
        RadioOptions.push(this.renderRadio('Other'));
        return RadioOptions;
    }

    renderRadio(value) {
        const { selected } = this.state;
        const isSelected = selected === value;
        const radioDataTag = value.replace(/\s/g, '-').replace('.', '').toLowerCase();

        return (
            <Radio
                key={value}
                name="reason"
                value={value}
                inputId={value}
                dataTn={radioDataTag}
                label={value}
                wrapperClass={styles.radioOption}
                checked={isSelected}
                onChange={selectedValue => this.onRadioClick(selectedValue)}
            />
        );
    }

    render() {
        const { selected, isOpen, isDisabled, additionalInfo } = this.state;
        const { itemId, orderType } = localStorage.getItem('checkoutSurveyInfo');
        const radioOptions = this.getRadioOptions();
        const baseDataTn = 'checkout-survey';

        return (
            <ModalContainer isOpen={isOpen} modalPosition="center" dataTn={baseDataTn} onClose={this.closeModal}>
                <ModalCloseButton onClick={this.closeModal} />
                <BarHeader title={copy.title} />
                <ModalBody>
                    <form
                        id="tfa_0"
                        method="post"
                        action="https://www.tfaforms.com/responses/processor"
                        data-tn={`${baseDataTn}-form`}
                        ref="form"
                        onSubmit={this.onSubmit}
                    >
                        <ExpandingArea
                            label={<div>{radioOptions}</div>}
                            expanded={selected}
                            maxHeight="320px"
                        >
                            <div className={styles.textareaWrapper}>
                                <TextArea
                                    label={copy.textAreaLabel}
                                    name="tfa_6"
                                    maxLength={1000}
                                    placeholder={copy.placeholder}
                                    dataTn={`${baseDataTn}-text-input`}
                                    onChange={this.onChange}
                                    value={additionalInfo}
                                />
                            </div>
                            <PrimaryButton
                                dataTn={`${baseDataTn}-submit`}
                                disabled={isDisabled}
                                onClick={this.onSubmit}
                                className={styles.submit}
                            >
                                {copy.submit}
                            </PrimaryButton>
                        </ExpandingArea>

                        <input type="hidden" id="tfa_9" name="tfa_9" value={navigator.userAgent} />
                        <input type="hidden" id="tfa_8" name="tfa_8" value={getCurrentUserId()} />
                        <input type="hidden" id="tfa_10" name="tfa_10" value={itemId} />
                        <input type="hidden" id="tfa_11" name="tfa_11" value={orderType} />
                        <input type="hidden" id="tfa_13" name="tfa_13" value={document.URL} />
                        <input type="hidden" id="tfa_12" name="tfa_12" value={selected} />

                        <input type="hidden" id="tfa_dbFormId" name="tfa_dbFormId" value="413075" />
                        <input type="hidden" id="tfa_dbControl" name="tfa_dbControl" value="c6cdf45727af0ab1bbf30b6ec6c49e33" />
                        <input type="hidden" id="tfa_dbVersionId" name="tfa_dbVersionId" value="5" />
                        <input type="hidden" id="tfa_switchedoff" name="tfa_switchedoff" value="" />
                        <input type="hidden" id="tfa_dbResponseId" name="tfa_dbResponseId" value="" />
                    </form>
                </ModalBody>
            </ModalContainer>
        );
    }
}

module.exports = CheckoutSurvey;



// WEBPACK FOOTER //
// ./src/abandonedCheckout/components/CheckoutSurvey.jsx